import React from "react"

import { Card, CardContent, Typography, Box, colors } from "@mui/material"
import { ArrowUpward, ArrowDownward } from "@mui/icons-material"
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer } from "recharts"

import { parseISO, format } from "date-fns"
import { ptBR } from "date-fns/locale"

export default function DashboardCard({
    title,
    value,
    percentage,
    timeframe,
    data,
}) {
    const isPositive = percentage >= 0

    return (
        <Card sx={{ borderRadius: 1, boxShadow: 1 }}>
            <CardContent>
                <Typography variant="subtitle2" color="text.secondary">
                    {title}
                </Typography>

                <Box display="flex" gap={1}>
                    <Box>
                        <Typography variant="h4" sx={{ mt: 1 }}>
                            {value?.toLocaleString()}
                        </Typography>
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={0.5}
                            sx={{ mt: 0.5 }}
                        >
                            {isPositive ? (
                                <ArrowUpward fontSize="small" color="success" />
                            ) : (
                                <ArrowDownward fontSize="small" color="error" />
                            )}

                            <Typography
                                variant="body2"
                                sx={{
                                    color: isPositive
                                        ? "success.main"
                                        : "error.main",
                                }}
                            >
                                {`${isPositive ? "+" : ""}${percentage?.toFixed(1)}%`}
                            </Typography>

                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{ ml: 0.5 }}
                                whiteSpace="nowrap"
                            >
                                {timeframe}
                            </Typography>
                        </Box>
                    </Box>
                    <Box width="100%" sx={{ mt: 2, height: 60 }}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={data}>
                                <XAxis dataKey="day" hide />
                                <Tooltip
                                    cursor={{ fill: "transparent" }}
                                    formatter={(value) => [
                                        `${value}`,
                                        "Negociações",
                                    ]}
                                    labelFormatter={(label) => {
                                        const parsedDate = parseISO(label)
                                        return format(parsedDate, "dd MMM", {
                                            locale: ptBR,
                                        })
                                    }}
                                    position={{
                                        y: -50,
                                        x: -20,
                                    }}
                                />
                                <Bar
                                    dataKey="value"
                                    fill={
                                        isPositive
                                            ? [colors.green[500]]
                                            : colors.red[500]
                                    }
                                    radius={[4, 4, 0, 0]}
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    )
}
